/** "ahora", "hace 5 min", "ayer": lo de la última semana, relativo; lo anterior, la fecha ("21 oct"). */
export function ago(iso: string, lang: string, now = Date.now()): string {
  const s = (now - Date.parse(iso)) / 1000;
  const rtf = new Intl.RelativeTimeFormat(lang, {
    numeric: "auto",
    style: "short",
  });
  if (s < 60) return rtf.format(0, "second");
  if (s < 3600) return rtf.format(-Math.round(s / 60), "minute");
  if (s < 86_400) return rtf.format(-Math.round(s / 3600), "hour");
  if (s < 7 * 86_400) return rtf.format(-Math.round(s / 86_400), "day");
  return new Date(iso).toLocaleDateString(lang, {
    day: "numeric",
    month: "short",
  });
}
